import { ReactNode } from 'react';

export interface GridLayoutItemProps {
  children: ReactNode;
  flexPercentage?: number;
  containerSpacing?: number;
}
const GridLayoutItem: React.FC<GridLayoutItemProps> = ({
  children,
  flexPercentage = 100,
  containerSpacing = 2,
}) => {
  const spacingPixels = containerSpacing * 8;
  return (
    <div style={{ flex: `Calc(${flexPercentage}% - ${spacingPixels}px)` }}>
      {children}
    </div>
  );
};

export default GridLayoutItem;
